<template>
    <v-card
        width="850"
        class="mx-auto pa-4 mt-4"        
        elevation="2"
        outlined
    >
        <v-tabs
            v-model="tab"
            grow
        >
            <v-tab
                v-for="item in tabOptions"
                :key="item"
            >
                {{ item }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab"> 
            <v-tab-item v-if="!formClassId">
                <edit-view-subjects 
                    v-bind:subjects="subjects"
                    v-on:update-subjects="initialize"
                ></edit-view-subjects>                  
            </v-tab-item>
            
            <v-tab-item v-if="!formClassId">
                <subjects-student-assignment
                    v-bind:subjects="subjects"
                    v-bind:teachers="teachers"
                ></subjects-student-assignment>                         
            </v-tab-item>

            <v-tab-item>
                <batch-student-subject-assignment
                    v-bind:subjects="subjects"
                    v-bind:teachers="teachers"
                    v-bind:formLevels="formLevels"
                    v-bind:formClasses="formClasses"
                    v-bind:students="students"
                    v-on:show-overlay="showOverlay"
                ></batch-student-subject-assignment>
            </v-tab-item>
               
        </v-tabs-items>
         
       <v-overlay
            absolute
            :value="overlay"
        >
            <v-progress-circular 
                indeterminate 
                size="64"                    
                color="white"
            ></v-progress-circular>   
        </v-overlay>

         
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditViewSubjects from './AdminSubjectsEditView';
import SubjectsStudentAssignment from './AdminSubjectsStudentAssignment';
import BatchStudentSubjectAssignment from './AdminSubjectsStudentBatch';
export default {
    created: function () {
        this.initialize();
    },

    components: {
        EditViewSubjects,
        SubjectsStudentAssignment,
        BatchStudentSubjectAssignment,
    },


    computed: {
        ...mapGetters({
            formClassId: 'auth/getFormClassId',
        })
    },
    
    data: () => ({
        
        subjects: [],
        teachers: [],
        formLevels: [],
        formClasses: [],
        students: [],
        tabOptions: [
            'Edit/View Subjects', 'Subject Student Assignment', 'Batch Assignment'
        ],
        tab: null,
        overlay: false,
    }),

    methods: {
        ...mapActions({            
            getSubjects: 'admin/getSubjects',            
            getEmployees: 'admin/getEmployees',
            getFormLevels: 'admin/getFormLevels',
            getFormClasses: 'admin/getFormClasses',
            getStudents: 'admin/getStudents',           
        }),

        async initialize () {
            console.log('initializing subjects...');
            if(this.formClassId){
                this.tabOptions = ['Student Subject Assignment'];
                this.tab = 2
            }

            this.overlay = true;

            try {
                const [
                    { data: dataSubjects },
                    { data: dataEmployees }, 
                    { data: dataFormLevels }, 
                    { data: dataFormClasses },
                    { data: dataStudents },
                ] = await Promise.all([
                    this.getSubjects(),
                    this.getEmployees(),
                    this.getFormLevels(),
                    this.getFormClasses(),
                    this.getStudents(),
                ])
                
                this.subjects = [...dataSubjects];
    
                this.teachers = dataEmployees.map(value => {
                    return {
                        name: value.first_name + ' ' + value.last_name,
                        display_name: value.first_name[0] + '. ' + value.last_name,                        
                        id: value.id
                    }
                });
    
                dataFormLevels.forEach(value => {
                    this.formLevels.push(value.form_level)
                })
    
                this.formClasses = dataFormClasses.filter(value => {
                    if(value.form_level) return value;
                });
    
                this.students = dataStudents.map(value => {
                    return {
                        id: value.id,
                        name: value.last_name + ' ' + value.first_name,
                        form_level: value.form_level,
                        class_id: value.class_id
                    }
                });
                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            console.log('subjects initialized...');
            this.overlay = false;
               
            
        },

        showOverlay (display = false) {
            this.overlay = display;            
        }

    }
}
</script>